// Create reverse Maps for each academic program type
const majorMap = new Map([
    ['African & African American Studies', 'AAAS'],
    ['Ancient Religion & Society', 'AncRel'],
    ['Art History', 'ArtHist'],
    ['Art History: Architecture', 'ArtHist-Arch'],
    ['Art History: Museum Theory & Practice', 'ArtHist-Mus'],
    ['Art History & Visual Arts', 'ArtVis'],
    ['Asian and Middle Eastern Studies', 'AMES'],
    ['Biology', 'Bio'],
    ['Biomedical Engineering', 'BME'],
    ['Biophysics', 'BioPhys'],
    ['Brazilian and Global Portuguese Studies', 'Port'],
    ['Chemistry', 'Chem'],
    ['Civil Engineering', 'CE'],
    ['Classical Civilization', 'ClasCiv'],
    ['Classical Languages', 'ClasLang'],
    ['Computational Media', 'CompMedia'],
    ['Computer Science', 'CompSci'],
    ['Cultural Anthropology', 'CulAnth'],
    ['Dance', 'Dance'],
    ['Earth and Climate Sciences', 'ECS'],
    ['Economics', 'Econ'],
    ['Electrical and Computer Engineering', 'ECE'],
    ['English', 'Engl'],
    ['Environmental Engineering', 'EnvE'],
    ['Environmental Sciences', 'Enviro'],
    ['Environmental Sciences and Policy', 'Enviro'],
    ['Evolutionary Anthropology', 'EvAnth'],
    ['French & Francophone Studies', 'French'],
    ['Gender, Sexuality, and Feminist Studies', 'GSF'],
    ['German', 'German'],
    ['Global Cultural Studies', 'GCS'],
    ['Global Health', 'GlHlth'],
    ['History', 'History'],
    ['Interdepartmental Major in Linguistics and Computer Science', 'LingCs'],
    ['Interdepartmental Major in Math and Computer Science on Data Science', 'MathCS'],
    ['Interdepartmental Major in Statistics and Computer Science on Data Science', 'StatCS'],
    ['Interdisciplinary Engineering & Applied Science', 'IDEAS'],
    ['International Comparative Studies', 'ICS'],
    ['Italian & European Studies', 'Italian'],
    ['Linguistics', 'Ling'],
    ['Marine Science & Conservation', 'MarSci'],
    ['Mathematics', 'Math'],
    ['Mechanical Engineering', 'ME'],
    ['Medieval and Renaissance Studies', 'MedRen'],
    ['Music', 'Music'],
    ['Neuroscience', 'Neuro'],
    ['Philosophy', 'Philo'],
    ['Physics', 'Phys'],
    ['Political Science', 'PoliSci'],
    ['Program II', 'ProgII'],
    ['Psychology', 'Psych'],
    ['Public Policy Studies', 'PubPol'],
    ['Religious Studies', 'Relig'],
    ['Romance Studies', 'RomSt'],
    ['Russian', 'Russian'],
    ['Slavic and Eurasian Studies', 'Slavic'],
    ['Sociology', 'Soc'],
    ['Spanish, Latin American, and Latino/a Studies', 'SLALS'],
    ['Statistical Science', 'Stats'],
    ['Theater Studies', 'Theater'],
    ['Visual Arts', 'VisArts'],
    ['Visual and Media Studies', 'VMS'],
    ['Visual & Media Studies: Cinematic Arts', 'VMS-CIN']
  ]);
  
  const minorMap = new Map([
    ['African & African American Studies', 'AAAS'],
    ['Art History', 'ArtHist'],
    ['Asian American & Diaspora Studies', 'AsianAm'],
    ['Asian and Middle Eastern Studies', 'AMES'],
    ['Biology', 'Bii'],
    ['Brazilian and Global Portuguese Studies', 'Port'],
    ['Chemistry', 'Chem'],
    ['Cinematic Arts', 'Cine'],
    ['Classical Archaeology', 'ClasArch'],
    ['Classical Civilization', 'ClasLang'],
    ['Computational Biology and Bioinformatics', 'CompBio'],
    ['Computational Media', 'CompMedia'],
    ['Computer Science', 'CompSci'],
    ['Creative Writing', 'CrWrit'],
    ['Cultural Anthropology', 'CulAnth'],
    ['Dance', 'Dance'],
    ['Earth and Climate Sciences', 'ECS'],
    ['Economics', 'Econ'],
    ['Education', 'Edu'],
    ['Electrical and Computer Engineering', 'ECE'],
    ['Energy Engineering', 'EngEn'],
    ['English', 'English'],
    ['Environmental Sciences and Policy', 'Enviro'],
    ['Evolutionary Anthropology', 'EvAnth'],
    ['Finance', 'Fin'],
    ['French & Francophone Studies', 'French'],
    ['Gender, Sexuality, and Feminist Studies', 'GSF'],
    ['German', 'German'],
    ['Global Cultural Studies', 'GCS'],
    ['Global Health', 'GlHlth'],
    ['Greek', 'Greek'],
    ['History', 'History'],
    ['Inequality Studies', 'IneqSt'],
    ['Italian Studies', 'Italian'],
    ['Journalism & Media', 'Journ'],
    ['Latin', 'Latin'],
    ['Linguistics', 'Ling'],
    ['Machine Learning & Artificial Intelligence', 'ML-AI'],
    ['Marine Science & Conservation', 'MarSci'],
    ['Mathematics', 'Math'],
    ['Medical Sociology', 'MedSoc'],
    ['Medieval and Renaissance Studies', 'MedRen'],
    ['Music', 'Music'],
    ['Musical Theater', 'MusTheatr'],
    ['Neuroscience', 'Neuro'],
    ['Philosophy', 'Philo'],
    ['Photography', 'Photo'],
    ['Physics', 'Phys'],
    ['Polish Culture and Language', 'Polish'],
    ['Political Science', 'PoliSci'],
    ['Psychology', 'Psych'],
    ['Religious Studies', 'Relig'],
    ['Russian and East European Literatures in Translation', 'RusLit'],
    ['Russian Culture and Language', 'Russian'],
    ['Sociology', 'Soc'],
    ['Spanish Studies', 'Span'],
    ['Statistical Science', 'Stats'],
    ['Theater Studies', 'Theatr'],
    ['Visual Arts', 'VisArts'],
    ['Visual and Media Studies', 'VMS'],
    ['Writing and Rhetoric', 'Writing']
  ]);
  
  const certMap = new Map([
    ['Aerospace Engineering', 'AeroEng'],
    ['Architectural Engineering', 'ArchEng'],
    ['Child Policy Research', 'ChildPol'],
    ['Decision Sciences', 'DecSci'],
    ['Digital Intelligence', 'DigInt'],
    ['Documentary Studies', 'DocSt'],
    ['East Asian Studies', 'EAS'],
    ['Energy and the Environment', 'Eng&Env'],
    ['Ethics & Society', 'Ethics'],
    ['Global Development Engineering', 'GlobDev'],
    ['Health Policy', 'HlthPol'],
    ['Human Rights', 'HumRts'],
    ['Information Science + Studies', 'ISS'],
    ['Innovation & Entrepreneurship', 'I&E'],
    ['Islamic Studies', 'IslamicSt'],
    ['Jewish Studies', 'JewishSt'],
    ['Latin American Studies', 'LatamSt'],
    ['Latino/Latina Studies in the Global South', 'LSGS'],
    ['Markets & Management', 'Mkts'],
    ['Materials Science & Engineering', 'MSE'],
    ['Philosophy, Politics and Economics', 'PPE'],
    ['Science & the Public', 'Sci&Pub'],
    ['Sustainability Engagement', 'Sustain']
  ]);

const getAll = () => {
  let names = new Set();
  majorMap.forEach((value, key) => {
    names.add(key)
  });
  minorMap.forEach((value, key) => {
    names.add(key)
  });
  certMap.forEach((value, key) => {
    names.add(key)
  });

  console.log(names);
  return Array.from(names);
}

const mergedMap = new Map([...majorMap, ...minorMap, ...certMap]);
  
export {majorMap, minorMap, certMap, getAll, mergedMap};